import { TConfiguredServicesDataTableData } from "@Modules/admin/integrationSettings/containers/mixedHandlers/atm/configuredServices/ConfiguredServicesDataTableMeta";

const ConfiguredServicesFakeData: TConfiguredServicesDataTableData[] = [
    {
        fdk: "448",
        offeredServices: "INTER CASH DEPOSIT",
        transactionType: "INTER CASH DEPOSIT",
        p1: "001",
        p2: "002",
        p3: "000",
        p4: "000",
        p5: "000",
        p6: "",
        p7: "",
        p8: "",
    },
    {
        fdk: "4488",
        offeredServices: "INTER CHECK DEPOSIT",
        transactionType: "INTER CHEQUE DEPOSIT",
        p1: "001",
        p2: "002",
        p3: "000",
        p4: "000",
        p5: "000",
        p6: "",
        p7: "",
        p8: "",
    },
    {
        fdk: "447",
        offeredServices: "INTER EXCHANGE RATE",
        transactionType: "INTER EXCHANGE RATE",
        p1: "001",
        p2: "002",
        p3: "000",
        p4: "000",
        p5: "",
        p6: "",
        p7: "",
        p8: "",
    },
    {
        fdk: "41",
        offeredServices: "INTER-RETRAIT",
        transactionType: "INTER-RETRAIT",
        p1: "001",
        p2: "002",
        p3: "000",
        p4: "004",
        p5: "",
        p6: "",
        p7: "",
        p8: "",
    },
    {
        fdk: "46",
        offeredServices: "INTER-VIREMENT",
        transactionType: "INTER-VIREMENT",
        p1: "001",
        p2: "002",
        p3: "000",
        p4: "004",
        p5: "",
        p6: "",
        p7: "",
        p8: "",
    },
]

export default ConfiguredServicesFakeData;